export default "__VITE_ASSET__CXBAucqt__"